import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import useNotifications from '../composables/useNotifications'
import NotificationWrapper from '../components/NotificationWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  props: {
  notificationWrapperClass: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const notifications = useNotifications()



function deactivate(id: number) {
  notifications.deactivate(id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).state.notifications, (notification) => {
      return (_openBlock(), _createBlock(NotificationWrapper, {
        key: notification.id,
        class: _normalizeClass(__props.notificationWrapperClass),
        notification: notification
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "notification", {
            notification: {
          ...notification,
          deactivate: () => deactivate(notification.id)
        }
          })
        ]),
        _: 2
      }, 1032, ["class", "notification"]))
    }), 128))
  ]))
}
}

})